import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Card, message } from 'antd'

import { getNowAcademicYear, getNowAcademicSemester } from '../../utils/dateUtil'

import storageUtils from '../../utils/storageUtils'
import { req_edit_ccw_works } from '../../api'

import RichTextEditor from './rich-text-editor'
import FileSource from './file-source'
import FilePng from './file-png'
import FileMp4 from './file-mp4'
import FilePdf from './file-pdf'

class StudentWorksEditModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////  

    static propTypes = {
        objectCollection: PropTypes.object,
        options: PropTypes.array
    }

    state = {
        isUpdate: true,
        isInsert: false,
        item: {
            Uid: '',
            AcademicYear: getNowAcademicYear(new Date()),
            AcademicSemester: getNowAcademicSemester(new Date()),

            ObjectCollectionNid: 0,
            ObjectCollectionName: '',
            ObjectCollectionDescription: '',

            ObjectOriginalName: '',
            ObjectOriginalFilePath: '',

            ObjectVideoName: '',
            ObjectVideoFilePath: '',

            ObjectImageName: '',
            ObjectImageFilePath: '',

            PowerOfAttorneyFilePath: '',

            CreativeCommonsLicense: 'COPYRIGHT',
            IsOriginality: 'YES',
            IsPublic: 'YES',
            ObjectType: '2D',

            ObjectOwner: '',
            ObjectOwnerName: '',

            ReferrerId: '',
            ReferrerName: '',

            CategoryCode: '0',
            CategoryName: '未分類',

            KeywordA: '',
            KeywordB: '',
            KeywordC: '',
            RecordCreateOperator: '',
        }
    }

    constructor(props) {
        super(props)

        this.get_source_file = React.createRef()
        this.get_png_file = React.createRef()
        this.get_mp4_file = React.createRef()
        this.get_pdf_file = React.createRef()

        this.editor = React.createRef()

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
 
    }

    UNSAFE_componentWillMount() {
        this.init()
    }

    componentDidMount() {
     
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_modify_item = async (item) => {
        item.condition = "BASE"
        //console.log(applycase)
        const result = await req_edit_ccw_works(item, storageUtils.getUser().token)
        if (result.status === "success") {
            // console.log(result)
            message.success(result.message)

        } else {
            message.error(result.message)
        }
    }
    // 數據配置設定 ////////////////////////////////////////////// 

    init = () => {
        if (this.props.objectCollection) {
            const item = this.props.objectCollection
            this.setState({ item })
        }
    }

    // 操作互動處理 //////////////////////////////////////////////

    handleChange(event) {
        const { item } = this.state
        //console.log(event)
        Object.keys(item).forEach(propertyName => {
            if (event.target.id === 'AgreePrivacy' && event.target.value !== null) {
                // Checkbox
                item.AgreePrivacy = event.target.checked
            } else {
                if (event.target.id === propertyName && event.target.value !== null) {
                    item[propertyName] = event.target.value.trim()
                }
            }
        });
        this.setState({ item })
    }

    handleSubmit(event) {
        event.preventDefault()

        const row = this.state.item
        const png_file = this.get_png_file.current.output_files() === undefined ? '' : this.get_png_file.current.output_files()
        const pdf_file = this.get_pdf_file.current.output_files() === undefined ? '' : this.get_pdf_file.current.output_files()
        const source_file = this.get_source_file.current.output_files() === undefined ? '' : this.get_source_file.current.output_files()
        const errors = []

        if (!row.ObjectCollectionName.trim()) {
            errors.push('作品名稱未填')
        }

        if (png_file === '') {
            errors.push('作品圖檔未上傳')
        }

        if (errors.length === 0) {
            row.ObjectOriginalFilePath = source_file === '' ? '' : source_file.url
            row.ObjectOriginalName = source_file === '' ? '' : source_file.name

            row.ObjectImageFilePath = png_file === '' ? '' : png_file.url
            row.ObjectImageName = png_file === '' ? '' : png_file.name

            if (!(row.ObjectType === '2D')) {
                const mp4_file = this.get_mp4_file.current.output_files() === undefined ? '' : this.get_mp4_file.current.output_files()
                row.ObjectVideoFilePath = mp4_file === '' ? '' : mp4_file.url
                row.ObjectVideoName = mp4_file === '' ? '' : mp4_file.name
            }

            row.PowerOfAttorneyFilePath = pdf_file === '' ? '' : pdf_file.url

            row.ObjectCollectionDescription = this.editor.current.output_text()

            const { ObjectOwner, ObjectOwnerName, ReferrerId, ReferrerName } = this.props.objectCollection

            row.ObjectOwner = ObjectOwner
            row.ObjectOwnerName = ObjectOwnerName

            row.ReferrerId = ReferrerId
            row.ReferrerName = ReferrerName

            row.RecordCreateOperator = storageUtils.getUser().userCode
            //console.log(row)

            this.api_modify_item(row)
        } else {
            let info = errors.join(',')
            message.error(info);
        }
    }

    //////////////////////////////////////////////////////////

    render() {
        const { options } = this.props
        const { Uid, CategoryCode, KeywordA, KeywordB, KeywordC, ObjectCollectionName, ObjectCollectionDescription, IsPublic, ObjectType, IsOriginality, CreativeCommonsLicense, ObjectOriginalName, ObjectOriginalFilePath, ObjectImageName, ObjectImageFilePath, ObjectVideoName,
            ObjectVideoFilePath, PowerOfAttorneyFilePath } = this.state.item

        const sourcefileUrlPath = '/api/UploadFile/AddInsideMediaFile'
        const sourceFile = ObjectOriginalFilePath === '' ? [] : [{
            Uid: Uid,
            FileNewName: ObjectOriginalName,
            FileUrl: ObjectOriginalFilePath
        }]
        const pngfileUrlPath = '/api/UploadFile/AddInsideMediaFile'
        const pngFile = ObjectImageFilePath === '' ? [] : [{
            Uid: Uid,
            FileNewName: ObjectImageName,
            FileUrl: ObjectImageFilePath
        }]
        const mp4fileUrlPath = '/api/UploadFile/AddInsideMediaFile'
        const mp4File = ObjectVideoFilePath === '' ? [] : [{
            Uid: Uid,
            FileNewName: ObjectVideoName,
            FileUrl: ObjectVideoFilePath
        }]
        const pdffileUrlPath = '/api/UploadFile/AddInsideDocFile'
        const pdfFile = PowerOfAttorneyFilePath === '' ? [] : [{
            Uid: Uid,
            FileNewName: '授權書',
            FileUrl: PowerOfAttorneyFilePath
        }]

        return (
            <Card>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <label>作品分類</label>
                                <select name="CategoryCode" id="CategoryCode" className="custom-select mb-3 text-success" style={{ backgroundColor: 'LightCyan' }} defaultValue={CategoryCode} onChange={this.handleChange} key={CategoryCode} >
                                    {options ? options.map((option, index) =>
                                        <option key={index} value={option.Value}>
                                            {option.Text}
                                        </option>
                                    ): ''}
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label>標籤一</label>
                                <input type="text" className="form-control text-primary" style={{ backgroundColor: 'LightYellow' }} id="KeywordA" placeholder="關鍵字" defaultValue={KeywordA} onChange={this.handleChange} />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label>標籤二</label>
                                <input type="text" className="form-control text-primary" style={{ backgroundColor: 'LightYellow' }} id="KeywordB" placeholder="關鍵字" defaultValue={KeywordB} onChange={this.handleChange} />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label>標籤三</label>
                                <input type="text" className="form-control text-primary" style={{ backgroundColor: 'LightYellow' }} id="KeywordC" placeholder="關鍵字" defaultValue={KeywordC} onChange={this.handleChange} />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <label><span className="text-danger">*</span>作品名稱</label>
                                <input type="text" className="form-control text-primary" style={{ backgroundColor: 'LightYellow' }} name="ObjectCollectionName" id="ObjectCollectionName" defaultValue={ObjectCollectionName} aria-describedby="mobileHelp" placeholder="請輸入作品名稱" onChange={this.handleChange} />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <label>作品說明</label>
                                <RichTextEditor ref={this.editor} edit_input_richtext={ObjectCollectionDescription} />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label>查詢瀏覽</label>
                                <select name="IsPublic" id="IsPublic" className="custom-select mb-3 text-success" style={{ backgroundColor: 'LightCyan' }} defaultValue={IsPublic} key={IsPublic} onChange={this.handleChange} >
                                    <option value="YES">開放</option>
                                    <option value="NO">關閉</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label>作品形式</label>
                                <select name="ObjectType" id="ObjectType" className="custom-select mb-3 text-success" style={{ backgroundColor: 'LightCyan' }} defaultValue={ObjectType} key={ObjectType} onChange={this.handleChange} >
                                    <option value="3D">3D/影片</option>
                                    <option value="2D">2D/圖片</option>
                                    <option value="OTHER">其他</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div className="form-group">
                                <label>作品來源</label>
                                <select name="IsOriginality" id="IsOriginality" className="custom-select mb-3 text-success" style={{ backgroundColor: 'LightCyan' }} defaultValue={IsOriginality} key={IsOriginality} onChange={this.handleChange} >
                                    <option value="YES">原創</option>
                                    <option value="NO">非原創</option>
                                    <option value="BOTH">其他</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-lg">
                            <div className="form-group">
                                <label>授權方式</label>
                                <select name="CreativeCommonsLicense" id="CreativeCommonsLicense" className="custom-select mb-3 text-success" style={{ backgroundColor: 'LightCyan' }} defaultValue={CreativeCommonsLicense} key={CreativeCommonsLicense} onChange={this.handleChange} >
                                    <option value="COPYRIGHT">版權所有/不對外授權</option>
                                    <option value="BYNCSA">非商業性分享/引用須標註</option>
                                    <option value="BOTH">無限制</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <span style={{ fontSize: '18px' }}> 檔案格式轉換請按此(網址: <a href='https://anyconv.com/tw/' rel="noreferrer" target='_blank' style={{ textDecoration: 'underline' }}>https://anyconv.com/tw/</a>)</span>
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label><span className="text-danger">*</span>作品圖檔上傳(<span style={{ color: 'blue' }}>PNG格式</span>)</label>
                                <FilePng ref={this.get_png_file} data_source={pngFile} api_url={pngfileUrlPath}></FilePng>
                            </div>
                        </div>
                        {ObjectType === '2D' ? '' : (<div className="col-lg-3">
                            <div className="form-group">
                                <label>作品影片上傳(<span style={{ color: 'blue' }}>MP4格式</span>)</label>
                                <FileMp4 ref={this.get_mp4_file} data_source={mp4File} api_url={mp4fileUrlPath}></FileMp4>
                            </div>
                        </div>)}
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label>授權書上傳(<span style={{ color: 'blue' }}>PDF格式</span>)</label>
                                <FilePdf ref={this.get_pdf_file} data_source={pdfFile} api_url={pdffileUrlPath}></FilePdf>
                            </div>
                        </div>
                        <div className="col-lg">
                            <div className="form-group">
                                <label>作品原始檔上傳(<span style={{ color: 'blue' }}>ZIP格式</span>)</label>
                                <FileSource ref={this.get_source_file} data_source={sourceFile} api_url={sourcefileUrlPath}></FileSource>
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <input type="submit" value="修改" className="btn btn-primary btn-sm btn-block" />
                    </div>
                </form>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(StudentWorksEditModal)